import { createAction } from 'redux-act';
//////////////////////////////////////////////////

export const openModal = createAction('openModal');
export const closeModal = createAction('closeModal');
export const closeModalById = createAction('closeModalById');
export const closeAllModals = createAction('closeAllModals');
